<script>
import { Dialog } from "element-ui";
export default {
  name: "aia-dialog",
  extends: Dialog
};
</script>